"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */


var KubraSVG = function KubraSVG() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 679 146.7"
  }, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: "-1356.32",
    y1: "-1682",
    x2: "-1355.613",
    y2: "-1682.707"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#20ac4b"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.983",
    stopColor: "#19361a"
  })), /*#__PURE__*/_react.default.createElement("polygon", {
    className: "st0 kubra",
    points: "213.9,0.8 194.8,0.8 126.7,83.7 126.7,0.8 111.4,0.8 111.4,144.4 126.7,144.4 126.7,104.2 150.9,76.1 195.3,144.4 213.9,144.4 161.6,63.6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st0 kubra",
    d: "M311.2,91.1c0,27.3-13.9,41.4-35.9,41.4c-22.6,0-36.3-15-36.3-42.1V0.8h-15.4v90.1c0,36.1,20.7,55.8,51.3,55.8 c31,0,51.7-19.7,51.7-56.6V0.8h-15.4V91.1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st0 kubra",
    d: "M415,70.6c11.9-4.7,23.6-14.4,23.6-33.4v-0.4c0-9.6-3.5-17.6-9.4-23.6c-8-8-20.3-12.3-35.5-12.3H345v143.6 h49.6c30.2,0,50-14.4,50-38.8V105C444.7,85.5,431.8,75.5,415,70.6z M360.4,14.8h32.4c19.1,0,30.2,9.2,30.2,24v0.4 c0,16.6-12.5,26.1-31.6,26.1h-31V14.8z M429.1,104.6c0,16.4-13.1,25.8-33.8,25.8h-34.9V78.8h33c23.2,0,35.7,9.4,35.7,25.4V104.6z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st0 kubra",
    d: "M624.2,0h-15.2l-50.8,133.9l-31.7-48.4c19.9-4.9,34.1-18.7,34.1-41.4v-0.4c0-12.1-4.1-22.4-11.3-29.5 C541.1,5.7,528,0.8,511.6,0.8h-49v143.6h15.4V88.6h32.6l36.1,55.8h7.6h10.8h5l13.9-37.7h64.6l13.9,37.7H679L624.2,0z M508.9,74.7 h-31V15h32.6c21.5,0,34.7,10.5,34.7,29.3v0.4C545.2,63,532.3,74.7,508.9,74.7z M589.2,92.7l27.3-72.8l27.1,72.8H589.2z"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    className: "st1 tri-top",
    points: "0,0.7 0,61.4 90.2,0.7"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    className: "st2 tri-mid",
    points: "2.9,72.7 100.1,138 100.1,7.3"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    className: "st0 tri-bottom",
    points: "0,84 0,144.7 90.2,144.7"
  }));
};

var _default = KubraSVG;
exports.default = _default;